/**
 * FAQ Module
 * Handles FAQ accordion functionality
 */

import { $$, on, toggleClass, hasClass } from '../utils/dom.js';
import { SELECTORS, CLASSES } from '../config/constants.js';

export class FAQ {
    constructor() {
        this.faqItems = $$(SELECTORS.FAQ_ITEMS);
        if (this.faqItems.length === 0) {
            console.warn('No FAQ items found');
            return;
        }
        this.init();
    }

    init() {
        this.setupAccordion();
    }

    /**
     * Setup FAQ accordion behavior
     */
    setupAccordion() {
        this.faqItems.forEach(item => {
            const question = item.querySelector(SELECTORS.FAQ_QUESTION);
            if (!question) return;

            on(question, 'click', () => {
                const isActive = hasClass(item, CLASSES.ACTIVE);

                // Close all other items
                this.faqItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        toggleClass(otherItem, CLASSES.ACTIVE, false);
                    }
                });

                // Toggle current item
                toggleClass(item, CLASSES.ACTIVE, !isActive);
            });
        });
    }

    /**
     * Open specific FAQ item by index
     * @param {number} index - Index of FAQ item to open
     */
    open(index) {
        if (index < 0 || index >= this.faqItems.length) return;
        const item = this.faqItems[index];
        const question = item.querySelector(SELECTORS.FAQ_QUESTION);
        if (question) question.click();
    }

    /**
     * Close all FAQ items
     */
    closeAll() {
        this.faqItems.forEach(item => {
            toggleClass(item, CLASSES.ACTIVE, false);
        });
    }
}
